<template>
  <div class="add-new">
    <v-container>
      <h2>Tilføj ny</h2>
    </v-container>
    <v-form>
      <v-container>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field label="Butik" outlined class="mb-0" v-model="item.store"></v-text-field>
            <v-currency-field label="Beløb" outlined class="mb-0" v-model="item.amount"></v-currency-field>
            <v-select :items="categories" label="Kategori" outlined v-model="item.category"></v-select>
            <v-text-field label="Evt. Beskrivelse" outlined class="mb-0" v-model="item.description"></v-text-field>
            <v-text-field
              label="Dato"
              outlined
              class="mb-0"
              v-if="showDate"
              v-model="item.transaction_date"
            ></v-text-field>
            <v-btn
              color="primary"
              class="mb-5"
              block
              :loading="loading"
              @click.prevent="saveNewItem"
            >Gem</v-btn>
            <v-btn color="primary" class="mb-10" @click="overlay = true" block>Ikke i dag?</v-btn>
            <v-btn color="secondary" class @click="backHome" block>Annuller</v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-overlay :value="overlay" color="#fff" opacity="0.9" class="pa-5">
        <v-date-picker
          v-model="item.transaction_date"
          class="mb-5"
          first-day-of-week="1"
          full-width
          light
          event-color="primary"
          locale="da-DK"
        ></v-date-picker>
        <v-btn color="primary" class="mb-3" @click="changeDate" block>Vælg dato</v-btn>
        <v-btn color="secondary" class @click="cancelDate" block>Annuller</v-btn>
      </v-overlay>
    </v-form>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      overlay: false,
      showDate: false,
      loading: false,
      item: {
        store: "",
        amount: "",
        transaction_date: moment().format('YYYY-MM-DD'),
        description: "",
        category: ""
      },
      categories: [
        "-",
        "Mad",
        "Diverse",
        "Børn",
        "Fastfood",
        "Cigaretter",
        "Gaver"
      ]
    };
  },
  computed: {
    ...mapGetters(["authToken"])
  },
  methods: {
    backHome() {
      this.$router.push("/index.html");
    },
    changeDate() {
      this.showDate = true;
      this.overlay = false;
    },
    cancelDate() {
      this.showDate = false;
      this.picker = new Date().toISOString().substr(0, 10);
      this.overlay = false;
    },
    async saveNewItem() {
      this.loading = true;
      if (this.item.store === "" || this.item.amount === "") {
        console.log("Butik og beløb skal udfyldes");
      } else {
        const config = {
          headers: {
            Authorization: "Bearer " + this.authToken
          }
        };
        const body = {
          title: this.item.store + ": " + this.item.amount,
          status: "publish",
          fields: this.item
        };
        let response = await axios.post(
          "https://spend.hjertezonen.dk/wp-json/wp/v2/transaction",
          // "https://spend-api.lndo.site/wp-json/wp/v2/transaction",
          body,
          config
        );
        this.loading = false;
        if (response.status === 201) {
          this.$router.push({ name: "home" });
        } else {
          console.log("Der skete en fejl");
        }
      }
    }
  }
};
</script>
